// extracted by mini-css-extract-plugin
export default {"emptyImage":"styles_emptyImage__13mHQ","image":"styles_image__prRh6"};